module.exports = __webpack_public_path__ + "static/img/icon_dkh@2x.ac72a801.png";